import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-no-wrap"},[(!_vm.uuid)?[_c(VIcon,{attrs:{"color":_vm.iconColor}},[_vm._v(_vm._s(_vm.icon))])]:[(['PENDING','STARTED'].includes(_vm.status))?_c(VProgressCircular,{attrs:{"indeterminate":!(_vm.uuid == _vm.$store.state.socket.progress.uuid),"value":_vm.$store.state.socket.progress.percentage,"size":_vm.size,"color":_vm.color,"width":_vm.width}}):_c(VIcon,{attrs:{"color":_vm.iconColor}},[_vm._v(_vm._s(_vm.icon))])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }